import React from "react";

import { getLocationString } from "../../utils/common";
import { validInterestOptionMap } from "../form-fields/common";
import { UserFormatableTextDisplay } from "../form-fields/UserFormatableText";
import AvatarImage from "../AvatarImage";
import useSWR from "swr";
import PageLoadingMessage from "../PageLoadingMessage";
import PageNotFound from "../../views/PageNotFound";

const getUserName = (member) => member.profile?.fullname || member.username;

const getLocation = ({ profile }) => getLocationString(profile || {});

const renderRelatedSkills = (skills) => {
  if (!skills) return "n/a";

  return skills
    .split(",")
    .map(
      (entry) => entry && entry.trim() // && (entry[0].toLocaleUpperCase() + entry.slice(1))
    )
    .join(", ");
};

const getOtherInterests = (otherInterests) =>
  renderRelatedSkills(otherInterests);

const ProfileInfo = ({ member }) => {
  if (!member.profile) {
    return (
      <h2 className="subtitle">This user has not set up their profile!</h2>
    );
  }

  const { profile } = member;

  return (
    <React.Fragment>
      <h2 className="subtitle block is-italic">
        {profile.intro || "no intro line..."}
      </h2>

      <h2 className="subtitle">{`A little about ${getUserName(member)}`}</h2>
      <UserFormatableTextDisplay
        value={profile.biography || "No biography..."}
      />

      <div className="columns">
        <div className="column">
          <div className="block">
            <strong>Related Interests</strong>
            <p>
              {profile.related_interests
                .map((interest) => validInterestOptionMap[interest])
                .join(", ") || "n/a"}
            </p>
          </div>

          <div className="block">
            <strong>Related Skills</strong>
            <p>{renderRelatedSkills(profile.skills)}</p>
          </div>
        </div>

        <div className="column">
          <div className="block">
            <strong>Other Interests</strong>
            <p>{getOtherInterests(profile.other_interests)}</p>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const MemberDetailsCard = ({ member }) => (
  <div className="card">
    <div className="card-image">
      <figure className="image is-square">
        <AvatarImage member={member} />
      </figure>
    </div>

    <div className="card-content">
      <div className="media-content">
        <p className="title is-4">{getUserName(member)}</p>
        <p className="subtitle is-6">{getLocation(member)}</p>
      </div>
    </div>
  </div>
);

const MemberDetails = ({ member }) => {
  if (!member?.id) {
    return <PageNotFound />;
  }

  return (
    <div className="container">
      <div className="columns">
        <div className="column is-one-third">
          <MemberDetailsCard member={member} />
        </div>

        <div className="column">
          <ProfileInfo member={member} />
        </div>
      </div>
    </div>
  );
};

export default MemberDetails;

export { MemberDetailsCard };
